<template>
    <div class="mx-auto text-center pt-12 mb-4 w-full">
        <h1 class="h1 mb-8">{{ name }}</h1>
        <p class="text-xl text-gray-400">Hello! Here are your notification settings</p>
        <p class="text-sm text-gray-400 sm:mb-4 mt-2">You can adjust them by editing below.</p>
    </div>

    <a :href="route('channels.setup')" class="mx-auto text-center w-full" v-if="not_configured_channels_count > 1">
        <div class="mx-auto text-center w-full">
            <div class="text-center py-4">
                <div class="p-2 bg-red-700 items-center text-indigo-100 leading-none rounded-full flex inline-flex hover:bg-red-600 transition cursor-pointer"
                    role="alert">
                    <span
                        class="flex rounded-full bg-red-800 uppercase px-2 py-1 text-xs font-bold mr-3 transition">Warning</span>
                    <span class="font-semibold mr-2 text-left flex-auto">You currently have no enabled channels, click here to configure them.</span>
                </div>
            </div>
        </div>
    </a>

    <div class="w-full flex flex-wrap justify-center">
        <!-- <notifyme frequency="daily" type="Daily" :channels="channels.filter(channel => channel.status === 'daily')" :categories="daily_categories" :count="daily_categories_count" /> -->
        <notifyme frequency="realtime" type="Real-time" :channels="channels.filter(channel => channel.status === 'realtime')"
                  :realtime_categories="real_time_categories"
                  :realtime_count="real_time_categories_count"
        :daily_categories="daily_categories"
        :daily_count="daily_categories_count"/>
    </div>
</template>
<script>

    export default {
        props: {
            name: {
                type: String
            },
            email_address: {
                required: false,
                type: String,
                default: 'test@test.com'
            },
            channels: {
                required: true,
                type: Array
            },
            real_time_categories: {
                required: true,
                type: Array
            },
            daily_categories: {
                required: true,
                type: Array
            },
            real_time_categories_count: {
                required: true,
                type: Number
            },
            daily_categories_count: {
                required: true,
                type: Number
            },
            not_configured_channels_count: {
                required: false,
                type: Number,
                default: 0
            }
        },
        data() {
            return {
                csrf_token: window.CSRF
            }
        }

    }

</script>
